import { getProjectState } from '@starflow/app/store';
import * as generatorUtils from '@starflow/app/modules/generator/helpers';
import { XINGLIU_MODEL_BASE_TYPE } from '@shakkerai/pro-constants';
// export const sdErrCodes = generatorUtils.sdErrCodes;

export const calcPreprocessorResolution = generatorUtils.calcPreprocessorResolution;

export const switchGlobalMode = generatorUtils.switchGlobalMode;

export const restoreGenerateParams = generatorUtils.restoreGenerateParams;

export const shouldApplyHiddenStrategy = generatorUtils.shouldApplyHiddenStrategy;

export const fetchHiddenStrategyParams = generatorUtils.fetchHiddenStrategyParams;

export const updateHiresOptions = generatorUtils.updateHiresOptions;

export const fixHiresOptions = generatorUtils.fixHiresOptions;

export const applyGenerateParams = generatorUtils.applyGenerateParams;

export const generateImage = () => {
  // 已废弃
};

export const getActiveGeneratorParameter = () => {
  let { currentNodeId, nodeMap } = getProjectState();
  const param = nodeMap?.[currentNodeId]?.data?.data;
  return param;
};

export const isStarFlowModel = (generator) => {
  const param = generator?.data;
  return param?.presetBaseModelId === 'base_checkpoint';
};

export const getActiveGeneratorId = () => {
  let { currentNodeId, nodeMap, units } = getProjectState();

  if (!nodeMap?.[currentNodeId] || nodeMap?.[currentNodeId]?.type !== 'generator') {
    currentNodeId = null;
  }

  if (!currentNodeId) {
    currentNodeId = units?.nodes?.find(
      (nodeId) => nodeMap?.[nodeId]?.data?.type === 'generator' || nodeMap?.[nodeId]?.type === 'generator',
    );
  }

  return currentNodeId;
};

export const applyGenerateResult = async (generatorId, images, params) => {
  // 已废弃
};

export const pollingAndUpdateTask = async (generatorId) => {
  // 已废弃
};

export const resumeInPorgressTasks = (taskMap) => {
  // 已废弃
};

export const initCollageGenerator = (imageIds) => {
  // 已废弃
};

export const prepareCollageSourceImage = async (generatorId, imageIds, groupId) => {};

export const initGroupCollageGenerator = (groupId) => {};

export const removeCollageGenerator = (generatorId) => {};

export const detailInfoToGenerateInfo = generatorUtils.detailInfoToGenerateInfo;
